
import { defineComponent, ref, computed } from "vue";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { useRouter } from "vue-router";
import { UserModel } from "@/models/user";
import { validateEmail } from "@/utils/plugins/geofirex/mixins/methodMixins";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  /* eslint-disable */
  name: "NavBar",
  data() {
    return {
      navbar: true,
      navbar1: false,
      eye: false,
      eye1: true,
      eye2: false,
      eye3: true,
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "user/is_loggedIn",
    }),
  },

  mounted() {
    var mainListDiv: any = document.getElementById("mainListDiv"),
      mediaButton: any = document.getElementById("mediaButton");

    mediaButton.onclick = function () {
      "use strict";
      mediaButton.classList.toggle("active");
      mainListDiv.classList.toggle("show_list");
    };
  },
  methods: {
    active() {
      var show: any = document.getElementsByClassName("show_list");
      if ((show = true)) {
        this.navbar = false;
        this.navbar1 = true;
      } else {
        this.navbar1 = false;
        this.navbar = true;
      }
    },
    ...mapActions({
      logout: "auth/logout",
    }),
    active1() {
      var show: any = document.getElementsByClassName("show_list");
      if ((show = true)) {
        this.navbar = true;
        this.navbar1 = false;
      }
    },
    account() {
      //@ts-ignore
      const $ = window.jQuery;
      $("#signupModal").modal("show");
      $("#loginModal").modal("hide");
    },
    account2() {
      //@ts-ignore
      const $ = window.jQuery;
      $("#loginModal").modal("show");
      $("#signupModal").modal("hide");
    },
    scrollToView(context: string) {
      if (this.$route.path !== "/") {
        // let p= document.querySelector('#contact')
        this.$router.push("/");
        setTimeout(() => {
          window.scrollY == 100;
          document.querySelector("#contact")?.scrollIntoView({
            behavior: "smooth",
          });
        }, 500);
      } else {
        document.querySelector("#contact")?.scrollIntoView({
          behavior: "smooth",
        });
      }
    },

    showEye() {
      var x: any = document.getElementById("password");
      if (x.type == "password") {
        x.type = "text";
        this.eye = true;
        this.eye1 = false;
        this.eye2 = true;
        this.eye3 = false;
      } else {
        x.type = "password";
        this.eye = false;
        this.eye1 = true;
        this.eye2 = false;
        this.eye3 = true;
      }
    },
    showEye1() {
      var x: any = document.getElementById("password1");
      if (x.type == "password") {
        x.type = "text";
        this.eye2 = true;
        this.eye3 = false;
      } else {
        x.type = "password";
        this.eye2 = false;
        this.eye3 = true;
      }
    },
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const toast = useToast();
    const email = ref("");
    const password = ref("");
    const password1 = ref("");
    const email1 = ref("");
    const user = ref(new UserModel());

    const loading = computed(() => store.getters["auth/getLoading"]);
    //@ts-ignore
    const $ = window.jQuery;

    async function login_with_email_and_password() {
      if (!email.value) {
        return toast.info("Please enter your Email Address");
      } else if (!validateEmail(email.value)) {
        return toast.info("Please enter a valid Email Address");
      } else if (!password.value) {
        return toast.info("Please enter your Password");
      }
      try {
        let response = await store.dispatch("auth/login_with_email_and_password", [email.value, password.value]);
        $("#loginModal").modal("hide");
        await router.push({ name: "home" });
        toast.success(response);
      } catch (e: any) {
        toast.error(e.message);
      }
    }

    async function sign_in_with_google() {
      try {
        let response = await store.dispatch("auth/sign_in_with_google");
        if (response.status && !response.isNewUser) {
          $("#loginModal").modal("hide");
          await router.push({ name: "home" });
          toast.success("Login successful", response.message);
        }
      } catch (e: any) {
        toast.error(e.message);
      }
    }

    async function sign_up_with_email_and_password() {
      //   if (!validateSecondForm()) {
      //     return false;
      //   }
      try {
        let response = await store.dispatch("auth/sign_up_with_email_and_password", [user.value, password.value]);
        $("#signupModal").modal("hide");
        await router.push({ name: "home" });
        toast.success(response);
      } catch (e: any) {
        toast.error("Failed to Sign Up ", e.message);
      }
    }

    async function reset_password() {
      let response = await store.dispatch("auth/reset_password", email.value);
      if (response.status) {
        $("#resetModal").modal("hide");
        await router.push({ name: "home" });
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    }

    function validateSecondForm() {
      if (!user.value.surname) {
        toast.info("First name field is required");
        return false;
      } else if (!user.value.firstName) {
        toast.info("Last name field is required");
        return false;
      } else if (!validateEmail(user.value.email)) {
        toast.info("Invalid Email Address");
        return false;
      } else if (!user.value.phone) {
        toast.info("Please enter your Phone number");
        return false;
      } else if (!password.value) {
        toast.info("Password field is required");
        return false;
      } else if (password1.value.length < 6) {
        toast.info("Password length must be greater than 5");
        return false;
      }
    }

    return {
      login_with_email_and_password,
      sign_in_with_google,
      loading,
      email,
      sign_up_with_email_and_password,
      password,
      reset_password,
      user,
      password1,
    };
  },
});
